import { useMemo, useState } from 'react'
import { LocalizationObject } from '../redux/slices/userSlice'
import { hasSettingsChanged } from '../utils/SettingsUtils'

export const useLocalization = (initialValues: LocalizationObject): any => {
    const [localization, setLocalization] =
        useState<LocalizationObject>(initialValues)
    const [savedLocalization] = useState<LocalizationObject>(initialValues)

    /* Compared against the values the form opened with, so changing a
       preference and changing it back is no longer an update. */
    const isLocalizationUpdated = useMemo(
        () => hasSettingsChanged(localization, savedLocalization),
        [localization, savedLocalization],
    )

    const handleLocalizationChange = (
        key: keyof LocalizationObject,
        value: string,
    ) => {
        setLocalization((prev) => {
            return {
                ...prev,
                [key]: value,
            }
        })
    }

    return {
        localization,
        setLocalization,
        handleLocalizationChange,
        isLocalizationUpdated,
    }
}
